import { createTRPCClient, createTRPCReact, httpBatchLink } from '@trpc/react-query';
import { type AnyTRPCRouter } from '@trpc/server';
import { transformer } from './transformer';

export function createClient<T extends AnyTRPCRouter = AnyTRPCRouter>() {
  return createTRPCReact<T>({});
}

export function createFetchClient<T extends AnyTRPCRouter = AnyTRPCRouter>(
  endpoint = '/api',
  url = process.env.NEXT_PUBLIC_BANZAI_CURRENT_SERVER!
) {
  return createTRPCClient<T>({
    links: [
      httpBatchLink<T>({
        transformer: transformer,
        url: `${url}${endpoint}`,
      }),
    ],
  });
}
